module.exports = __webpack_public_path__ + "img/icon-notifications.700d2f7a.svg";